import type { OpcionArmado } from '../components/ArmarPresupuesto.js';

/**
 * El aviso de una fila que entra con «lo más parecido» del catálogo (no el concepto exacto). Dice QUÉ pide el plano y qué es lo
 * que va, con el porqué de la IA, no un «revísalo» genérico.
 *
 * «La diferencia es de detalle y no cambia el precio» solo se afirma si el plano dice todo lo que importa para el precio. Si el plano
 * NO dice algo (p. ej. el material: `noSeSabe`), esa afirmación no se sostiene —la IA recibió la orden de no exigir lo que los datos
 * no dicen, y entonces «no afecta el precio» era una consecuencia de la orden, no un hecho—: se avisa de lo que falta y se pide revisar.
 */
export function notaDelMasParecido(notaFaltante: string, o: OpcionArmado, noSeSabe: readonly string[] = []): string {
  const porque = o.razon?.trim() ? ` (${o.razon.trim().replace(/\.$/, '')})` : '';
  if (o.afectaPrecio === false && noSeSabe.length === 0) {
    return `Va ${o.clave}${porque}: no es idéntico a lo del plano, pero la diferencia es de detalle y no cambia el precio de forma importante.`;
  }
  const falta = /no hay (.+?)\.(?:\s|$)/i.exec(notaFaltante)?.[1]?.trim();
  const va = `${o.clave} «${o.descripcion.replace(/\s+/g, ' ').trim().slice(0, 90)}${o.descripcion.length > 90 ? '…' : ''}»`;
  const base = falta
    ? `El plano pide ${falta} y tu catálogo no lo tiene. Va lo más parecido: ${va}${porque}. Revísalo o cámbialo.`
    : `${notaFaltante.replace(/\s*Búscalo en.*$/, '')} Va lo más parecido: ${va}${porque}. Revísalo o cámbialo.`;
  return noSeSabe.length ? `${base} El plano no dice ${noSeSabe.join(', ')}, y eso puede cambiar el precio.` : base;
}
